// extracted by mini-css-extract-plugin
export var infoItem = "_t8-2";
export var title = "_t8-0";
export var value = "_t8-1";